import apiClient from './axios';

// 全域記憶體快取：避免同一個 memberId 在聊天室內被重複請求。
// 查無資料（404 等）也快取為 null，避免對同一個不存在的 memberId 重複打 API。
const memberCache = new Map();
const pendingRequests = new Map();

export const getCachedMember = (memberId) => memberCache.get(memberId);

export const fetchMemberById = async (memberId) => {
  if (memberId == null) return null;

  if (memberCache.has(memberId)) {
    return memberCache.get(memberId);
  }

  if (pendingRequests.has(memberId)) {
    return pendingRequests.get(memberId);
  }

  const request = apiClient
    .get(`/members/${memberId}`)
    .then((response) => {
      memberCache.set(memberId, response.data);
      return response.data;
    })
    .catch(() => {
      memberCache.set(memberId, null);
      return null;
    })
    .finally(() => {
      pendingRequests.delete(memberId);
    });

  pendingRequests.set(memberId, request);
  return request;
};
